// Public camp form client. Vanilla ES served as a static asset (no
// bundler, no imports) — matches the convention of the sibling external
// apps. The page embeds its config as JSON in <script id="bundle-json">;
// this file reads it and renders the form.
//
// Phase 1b scope: form UI + client state + live price estimate + signature.
// NO submit pipeline yet — the submit button stays disabled; Phase 1c wires
// POST /:token once the server-side submit handler is ready.
//
// The price estimate here mirrors routes/routes/modules/camp-pricing-engine.js
// deliberately. The server is authoritative; this is purely so parents see a
// plausible total before the review/payment step. If the engine changes,
// remember to mirror the change here.
(function () {
  "use strict";

  var bundle = readJSON("bundle-json");
  var token = readJSON("token-json");

  if (!bundle || !bundle.summer) {
    // Defensive: the server should have already rendered 404 in this case.
    return;
  }

  var YEAR_VALUES = {
    "Nursery": -1,
    "Reception": 0,
    "Year 1": 1, "Year 2": 2, "Year 3": 3, "Year 4": 4,
    "Year 5": 5, "Year 6": 6, "Year 7": 7, "Year 8": 8,
  };

  // Mirrors yearOrdinal in the engine. Accepts numeric or label-string
  // tier bounds (legacy data may still be strings until V296 runs).
  function yearOrdinal(v) {
    if (v == null || v === "") return null;
    if (typeof v === "number") return isFinite(v) ? v : null;
    if (Object.prototype.hasOwnProperty.call(YEAR_VALUES, v)) return YEAR_VALUES[v];
    var n = Number(v);
    return isFinite(n) ? n : null;
  }

  var form = document.getElementById("camp-form");
  var childrenContainer = document.getElementById("children-container");
  var addChildBtn = document.getElementById("add-child-btn");
  var childTemplate = document.getElementById("child-template");
  var reviewContent = document.getElementById("review-content");
  var signaturePad = document.getElementById("signature-pad");
  var signatureClearBtn = document.getElementById("signature-clear");
  var submitBtn = document.getElementById("submit-btn");
  var submitHint = document.getElementById("submit-hint");
  var submitError = document.getElementById("submit-error");

  var childIndex = 0;

  // ----------------------------------------------------------------
  // Utilities
  // ----------------------------------------------------------------

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatDate(iso) {
    if (!iso) return "";
    // ISO YYYY-MM-DD -> DD Mon YYYY. Split/avoid Date parsing to sidestep
    // timezone shifts on 'YYYY-MM-DD' strings.
    var parts = String(iso).split("-");
    if (parts.length !== 3) return iso;
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var m = months[parseInt(parts[1], 10) - 1] || "";
    return parseInt(parts[2], 10) + " " + m + " " + parts[0];
  }

  function formatMoney(n) {
    var sign = n < 0 ? "-" : "";
    return sign + "£" + Math.abs(n).toFixed(2);
  }

  function escapeHtml(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  // Lightweight in-page confirmation modal. The external form is vanilla JS
  // with no bootbox/jquery/bootstrap — pulling those in just for a single
  // confirm dialog would triple the payload served to scanners. Uses the
  // styles in form.css (.modal-backdrop / .modal-dialog). Keyboard: Escape
  // cancels, Enter confirms.
  function confirmDialog(opts) {
    return new Promise(function (resolve) {
      var backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop";
      backdrop.innerHTML =
        '<div class="modal-dialog" role="dialog" aria-modal="true">' +
        '<h3>' + escapeHtml(opts.title || "Are you sure?") + '</h3>' +
        '<p>' + escapeHtml(opts.message || "") + '</p>' +
        '<div class="modal-actions">' +
        '<button type="button" class="btn secondary" data-confirm-cancel>' + escapeHtml(opts.cancelLabel || "Cancel") + '</button>' +
        '<button type="button" class="btn primary" data-confirm-ok>' + escapeHtml(opts.confirmLabel || "OK") + '</button>' +
        '</div></div>';
      function cleanup(result) {
        document.removeEventListener("keydown", onKey);
        if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
        resolve(!!result);
      }
      function onKey(e) {
        if (e.key === "Escape") cleanup(false);
        else if (e.key === "Enter") cleanup(true);
      }
      backdrop.querySelector("[data-confirm-cancel]").addEventListener("click", function () { cleanup(false); });
      backdrop.querySelector("[data-confirm-ok]").addEventListener("click", function () { cleanup(true); });
      backdrop.addEventListener("click", function (e) { if (e.target === backdrop) cleanup(false); });
      document.addEventListener("keydown", onKey);
      document.body.appendChild(backdrop);
      backdrop.querySelector("[data-confirm-ok]").focus();
    });
  }

  // ----------------------------------------------------------------
  // Children repeater
  // ----------------------------------------------------------------

  function addChild() {
    childIndex += 1;
    var node = childTemplate.content.firstElementChild.cloneNode(true);
    node.dataset.id = "child-" + childIndex;
    node.querySelector("[data-child-index]").textContent = childrenContainer.children.length + 1;

    populateFormsSelect(node);
    populateSessions(node);
    populateAddOns(node);
    populateTransport(node);

    node.querySelector("[data-remove-child]").addEventListener("click", function () {
      node.remove();
      renumberChildren();
      updateReview();
    });

    // Any input change on the child card re-renders the review.
    node.addEventListener("input", updateReview);
    node.addEventListener("change", updateReview);

    childrenContainer.appendChild(node);
    renumberChildren();
    updateReview();
  }

  function renumberChildren() {
    var cards = childrenContainer.querySelectorAll("[data-child]");
    cards.forEach(function (card, i) {
      card.querySelector("[data-child-index]").textContent = i + 1;
      var removeBtn = card.querySelector("[data-remove-child]");
      // Keep at least one child card visible.
      removeBtn.disabled = cards.length <= 1;
      removeBtn.style.visibility = cards.length <= 1 ? "hidden" : "visible";
    });
  }

  function populateFormsSelect(node) {
    var select = node.querySelector("[data-forms-select]");
    (bundle.forms || []).forEach(function (f) {
      var opt = document.createElement("option");
      opt.value = f.id;
      opt.textContent = f.form;
      select.appendChild(opt);
    });
  }

  function populateSessions(node) {
    var container = node.querySelector("[data-sessions-container]");
    container.className = "sessions-list";
    (bundle.sessions || []).forEach(function (s) {
      var row = document.createElement("label");
      row.className = "session-row";
      var dates = "";
      if (s.start_date && s.end_date) {
        dates = formatDate(s.start_date) + " – " + formatDate(s.end_date);
      } else if (s.start_date) {
        dates = formatDate(s.start_date);
      }
      row.innerHTML =
        '<input type="checkbox" data-session-id="' + escapeHtml(s.id) + '">' +
        '<span class="session-name">' + escapeHtml(s.name) + '</span>' +
        (dates ? '<span class="session-dates">' + escapeHtml(dates) + '</span>' : "");
      container.appendChild(row);
    });
  }

  function populateAddOns(node) {
    var addOns = (bundle.summer && bundle.summer.add_ons) || [];
    if (!Array.isArray(addOns) || !addOns.length) return;
    var subpanel = node.querySelector("[data-addons-subpanel]");
    subpanel.hidden = false;
    var container = node.querySelector("[data-addons-container]");
    container.className = "addons-list";

    addOns.forEach(function (addOn, addOnIdx) {
      if (!addOn || !addOn.name) return;
      var groupName = "addon-" + node.dataset.id + "-" + addOnIdx;
      var row = document.createElement("div");
      row.className = "addon-row";
      // A "None" option is prepended (and pre-selected) so parents can opt out
      // without admin having to manually add a zero-price "None" entry. Pricing
      // engine ignores values that don't match any option label (see
      // pricing-engine.js :: add-on lookup), so "None" adds nothing to the total.
      var noneOptionHtml = '<label>' +
        '<input type="radio" name="' + escapeHtml(groupName) + '" ' +
        'data-addon-name="' + escapeHtml(addOn.name) + '" ' +
        'value="" checked>' +
        'None' +
        '</label>';
      var optionsHtml = noneOptionHtml + (addOn.options || []).map(function (opt) {
        var priceTxt = opt.price ? " (+" + formatMoney(Number(opt.price)) + ")" : "";
        return '<label>' +
          '<input type="radio" name="' + escapeHtml(groupName) + '" ' +
          'data-addon-name="' + escapeHtml(addOn.name) + '" ' +
          'value="' + escapeHtml(opt.label) + '">' +
          escapeHtml(opt.label) + escapeHtml(priceTxt) +
          '</label>';
      }).join("");
      row.innerHTML =
        '<strong>' + escapeHtml(addOn.name) + '</strong>' +
        '<div class="addon-options">' + optionsHtml + '</div>';
      container.appendChild(row);
    });
  }

  function populateTransport(node) {
    var transport = bundle.summer && bundle.summer.transport;
    if (!transport) return;
    var subpanel = node.querySelector("[data-transport-subpanel]");
    subpanel.hidden = false;

    var locationSelect = subpanel.querySelector("[data-field='transport_location']");
    var locations = (bundle.summer.transport_locations) || [];
    locations.forEach(function (loc) {
      var opt = document.createElement("option");
      var label = (loc && (loc.name || loc.label || loc)) + "";
      opt.value = label;
      opt.textContent = label;
      locationSelect.appendChild(opt);
    });

    // Per-session transport checkboxes — visible only once a location is picked.
    var sessionsWrap = subpanel.querySelector("[data-transport-sessions]");
    (bundle.sessions || []).forEach(function (s) {
      var row = document.createElement("label");
      row.className = "transport-row";
      var fee = bundle.summer.transport_fee ? " (+" + formatMoney(Number(bundle.summer.transport_fee)) + ")" : "";
      row.innerHTML =
        '<input type="checkbox" data-transport-session-id="' + escapeHtml(s.id) + '">' +
        '<span>' + escapeHtml(s.name) + escapeHtml(fee) + '</span>';
      sessionsWrap.appendChild(row);
    });

    locationSelect.addEventListener("change", function () {
      var has = !!locationSelect.value;
      sessionsWrap.hidden = !has;
      if (!has) {
        sessionsWrap.querySelectorAll("input[type='checkbox']").forEach(function (cb) { cb.checked = false; });
      }
    });
  }

  // ----------------------------------------------------------------
  // Pricing mirror (matches routes/routes/modules/camp-pricing-engine.js)
  // ----------------------------------------------------------------

  function toNumber(v) {
    if (v == null || v === "") return 0;
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  function matchesTier(tier, child) {
    var t = tier.criteria_type;
    var c = tier.criteria_value || {};
    if (t === "none") return true;
    if (t === "dob_before") {
      if (!child.dob || !c.dob) return false;
      return String(child.dob) < String(c.dob);
    }
    if (t === "year_group_range") {
      var y = YEAR_VALUES[child.school_year];
      if (y === undefined) return false;
      var min = yearOrdinal(c.min_year);
      var max = yearOrdinal(c.max_year);
      if (min != null && y < min) return false;
      if (max != null && y > max) return false;
      return true;
    }
    if (t === "form") {
      if (!child.form_id) return false;
      var ids = Array.isArray(c.form_ids) ? c.form_ids : [];
      return ids.indexOf(child.form_id) >= 0;
    }
    return false;
  }

  function pickTier(child) {
    var tiers = (bundle.tiers || []).slice().sort(function (a, b) {
      return (a.sort_order || 0) - (b.sort_order || 0);
    });
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].is_default) continue;
      if (matchesTier(tiers[i], child)) return tiers[i];
    }
    var dflt = tiers.filter(function (t) { return t.is_default; })[0];
    if (dflt) return dflt;
    return tiers[0] || null;
  }

  function sessionCombosEqual(a, b) {
    if (a.length !== b.length) return false;
    var setA = {};
    a.forEach(function (x) { setA[x] = 1; });
    for (var i = 0; i < b.length; i++) if (!setA[b[i]]) return false;
    return true;
  }

  function pickPricingRule(tierId, sessionIds) {
    var rules = bundle.rules || [];
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].tier_id !== tierId) continue;
      var combo = Array.isArray(rules[i].session_combo) ? rules[i].session_combo : [];
      if (sessionCombosEqual(combo, sessionIds)) return rules[i];
    }
    return null;
  }

  function priceChild(child) {
    var items = [];
    var warnings = [];
    var tier = pickTier(child);
    if (!tier) warnings.push("No pricing tier matched.");

    if (tier && child.sessionIds.length) {
      var rule = pickPricingRule(tier.id, child.sessionIds);
      if (!rule) {
        warnings.push("No pricing rule found for this session combination.");
      } else {
        (rule.invoice_items || []).forEach(function (it) {
          var desc = (it.description || "").trim();
          if (!desc) return;
          items.push({ description: desc, amount: toNumber(it.amount) });
        });
      }
    }

    // Add-ons
    var addOnsRaw = bundle.summer && bundle.summer.add_ons;
    var addOns = Array.isArray(addOnsRaw) ? addOnsRaw : [];
    addOns.forEach(function (ao) {
      var picked = child.addOnSelections[ao.name];
      if (!picked) return;
      var opt = (ao.options || []).filter(function (o) { return o.label === picked; })[0];
      if (!opt) return;
      var amt = toNumber(opt.price);
      if (amt === 0) return;
      items.push({ description: ao.name + " — " + opt.label, amount: amt });
    });

    // Transport
    if (bundle.summer.transport && child.transportSessionIds.length) {
      var fee = toNumber(bundle.summer.transport_fee);
      if (fee > 0) {
        var byId = {};
        (bundle.sessions || []).forEach(function (s) { byId[s.id] = s; });
        child.transportSessionIds.forEach(function (sid) {
          items.push({
            description: "Transport — " + ((byId[sid] && byId[sid].name) || "Session"),
            amount: fee,
          });
        });
      }
    }

    return { tier: tier, items: items, warnings: warnings };
  }

  // Per-session, per-qualifying-child sibling discount. Mirrors the
  // server-side engine. `sessionSiblingContext` is { [sessionId]: { count, index } }
  // — count is the number of children in this submission booked into the
  // session, index is this child's 0-based position among them (by their
  // order in the form, which becomes sibling_share_index).
  function siblingDiscountItems(sessionSiblingContext) {
    if (!sessionSiblingContext) return [];
    var rules = bundle.siblingRules || [];
    if (!rules.length) return [];
    var sortedRules = rules.slice().sort(function (a, b) {
      return Number(b.min_children) - Number(a.min_children);
    });
    var byId = {};
    (bundle.sessions || []).forEach(function (s) { byId[s.id] = s; });
    var out = [];
    Object.keys(sessionSiblingContext).forEach(function (sid) {
      var ctx = sessionSiblingContext[sid];
      if (!ctx || !ctx.count) return;
      var rule = null;
      for (var i = 0; i < sortedRules.length; i++) {
        if (ctx.count >= Number(sortedRules[i].min_children || 0)) {
          rule = sortedRules[i]; break;
        }
      }
      if (!rule) return;
      if (ctx.index < Number(rule.min_children) - 1) return;
      var sessionName = (byId[sid] && byId[sid].name) || "Session";
      (rule.invoice_items || []).forEach(function (item) {
        var desc = (item.description || "").trim();
        var amt = toNumber(item.amount);
        if (!desc) return;
        out.push({ description: desc + " (" + sessionName + ")", amount: amt });
      });
    });
    return out;
  }

  // Build sessionSiblingContext for one child in the in-progress submission.
  // `children` is the array of readChildState results (in form order); the
  // child at `thisIdx` is the one being priced.
  function buildSessionSiblingContext(children, thisIdx) {
    var thisChild = children[thisIdx];
    if (!thisChild) return {};
    var ctx = {};
    (thisChild.sessionIds || []).forEach(function (sid) {
      var inSession = [];
      children.forEach(function (c, i) {
        if ((c.sessionIds || []).indexOf(sid) !== -1) inSession.push({ i: i });
      });
      var index = -1;
      for (var k = 0; k < inSession.length; k++) {
        if (inSession[k].i === thisIdx) { index = k; break; }
      }
      ctx[sid] = { count: inSession.length, index: index };
    });
    return ctx;
  }

  // ----------------------------------------------------------------
  // Read child state out of its DOM
  // ----------------------------------------------------------------

  function readChildState(card) {
    function field(name) {
      var el = card.querySelector("[data-field='" + name + "']");
      if (!el) return "";
      if (el.type === "checkbox") return el.checked;
      return el.value;
    }
    var sessionIds = Array.from(card.querySelectorAll("[data-session-id]:checked"))
      .map(function (cb) { return cb.getAttribute("data-session-id"); });
    var transportSessionIds = Array.from(card.querySelectorAll("[data-transport-session-id]:checked"))
      .map(function (cb) { return cb.getAttribute("data-transport-session-id"); });
    var addOnSelections = {};
    card.querySelectorAll("[data-addon-name]:checked").forEach(function (r) {
      // Skip the "None" radio's empty value so the payload only lists add-ons
      // the parent actually picked.
      if (!r.value) return;
      addOnSelections[r.getAttribute("data-addon-name")] = r.value;
    });

    return {
      first_name: field("first_name"),
      last_name: field("last_name"),
      jewish_name: field("jewish_name"),
      dob: field("dob"),
      gender: field("gender"),
      school: field("school"),
      school_year: field("school_year"),
      form_id: field("form_id"),
      medical: field("medical"),
      allergies: field("allergies"),
      special_needs: field("special_needs"),
      tetanus: field("tetanus"),
      tetanus_year: field("tetanus_year"),
      contact_consent: field("contact_consent"),
      transport_location: field("transport_location"),
      sessionIds: sessionIds,
      transportSessionIds: transportSessionIds,
      addOnSelections: addOnSelections,
    };
  }

  // ----------------------------------------------------------------
  // Review / price estimate
  // ----------------------------------------------------------------

  function updateReview() {
    var cards = Array.from(childrenContainer.querySelectorAll("[data-child]"));
    if (!cards.length) {
      reviewContent.innerHTML = '<p class="hint">Add at least one child and select sessions to see a price estimate.</p>';
      return;
    }

    var lines = [];
    var grandTotal = 0;
    var anyWarnings = [];

    var children = cards.map(readChildState);

    cards.forEach(function (card, i) {
      var child = children[i];
      var label = [child.first_name, child.last_name].filter(Boolean).join(" ").trim() || ("Child " + (i + 1));

      lines.push('<div class="review-child-header">' + escapeHtml(label) + '</div>');

      var priced = priceChild(child);
      if (priced.tier) {
        lines.push('<div class="review-line"><span>Pricing tier</span><span>' + escapeHtml(priced.tier.name) + '</span></div>');
      }
      if (!child.sessionIds.length) {
        lines.push('<div class="review-line hint"><span>No sessions selected yet.</span><span></span></div>');
      }
      priced.items.forEach(function (it) {
        lines.push('<div class="review-line"><span>' + escapeHtml(it.description) + '</span><span>' + formatMoney(it.amount) + '</span></div>');
        grandTotal += it.amount;
      });
      // Per-session sibling discount lines belong on this child's invoice
      // (they're emitted by the engine for each session where this child
      // qualifies).
      var sibItems = siblingDiscountItems(buildSessionSiblingContext(children, i));
      sibItems.forEach(function (it) {
        lines.push('<div class="review-line"><span>' + escapeHtml(it.description) + '</span><span>' + formatMoney(it.amount) + '</span></div>');
        grandTotal += it.amount;
      });
      priced.warnings.forEach(function (w) { anyWarnings.push(label + ": " + w); });
    });

    lines.push('<div class="review-line total"><span>Estimated total</span><span>' + formatMoney(grandTotal) + '</span></div>');

    if (anyWarnings.length) {
      lines.push(
        '<div class="validation-error" style="margin-top:0.5rem;">' +
        anyWarnings.map(escapeHtml).join("<br>") +
        '</div>'
      );
    }

    reviewContent.innerHTML = lines.join("");
  }

  // ----------------------------------------------------------------
  // Signature pad (mouse + touch)
  // ----------------------------------------------------------------

  function initSignaturePad() {
    var ctx = signaturePad.getContext("2d");
    var drawing = false;
    var signed = false;
    // CSS-px size + devicePixelRatio the buffer was last sized for, so
    // rebufferIfNeeded can tell a real size change from iOS URL-bar churn.
    var bufferedWidth = 0;
    var bufferedHeight = 0;
    var bufferedRatio = 0;

    function resize() {
      var ratio = window.devicePixelRatio || 1;
      var rect = signaturePad.getBoundingClientRect();
      bufferedWidth = rect.width;
      bufferedHeight = rect.height;
      bufferedRatio = ratio;
      signaturePad.width = rect.width * ratio;
      signaturePad.height = rect.height * ratio;
      ctx.scale(ratio, ratio);
      ctx.lineWidth = 2;
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      ctx.strokeStyle = "#1f2933";
    }

    // Re-buffer (preserving ink) only when the canvas's on-screen size or
    // devicePixelRatio actually changed. Reassigning canvas.width resets ALL
    // context state including an in-flight stroke's path, and iOS Safari
    // fires window resize on every URL-bar collapse/expand (in-app browsers
    // also fire it on keyboard dismissal) — the old unconditional handler
    // made strokes drawn around those moments silently vanish. Never runs
    // mid-stroke; start() re-checks at the next stroke boundary, so a real
    // size change (e.g. rotation) is still applied before any new ink.
    function rebufferIfNeeded() {
      if (drawing) return;
      var ratio = window.devicePixelRatio || 1;
      var rect = signaturePad.getBoundingClientRect();
      // Hidden (post-submit) — a 0x0 rebuffer would discard the ink.
      if (!rect.width || !rect.height) return;
      if (ratio === bufferedRatio &&
          Math.abs(rect.width - bufferedWidth) < 0.5 &&
          Math.abs(rect.height - bufferedHeight) < 0.5) return;
      // Preserve content by copying to an offscreen canvas then restoring.
      // (drawImage throws on a 0x0 source, hence the guard.)
      var tmp = null;
      if (signaturePad.width && signaturePad.height) {
        tmp = document.createElement("canvas");
        tmp.width = signaturePad.width;
        tmp.height = signaturePad.height;
        tmp.getContext("2d").drawImage(signaturePad, 0, 0);
      }
      resize();
      if (tmp) ctx.drawImage(tmp, 0, 0, bufferedWidth, bufferedHeight);
    }

    function pointFrom(e) {
      var rect = signaturePad.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return { x: clientX - rect.left, y: clientY - rect.top };
    }

    function start(e) {
      // Stroke boundary: apply any buffer resize deferred while drawing.
      // drawing is force-cleared first so a missed touchend/touchcancel can
      // never wedge the rebuffer guard shut.
      drawing = false;
      rebufferIfNeeded();
      drawing = true;
      var p = pointFrom(e);
      ctx.beginPath();
      ctx.moveTo(p.x, p.y);
      e.preventDefault();
    }

    function move(e) {
      if (!drawing) return;
      var p = pointFrom(e);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      signed = true;
      e.preventDefault();
    }

    function end() { drawing = false; }

    signaturePad.addEventListener("mousedown", start);
    signaturePad.addEventListener("mousemove", move);
    signaturePad.addEventListener("mouseup", end);
    signaturePad.addEventListener("mouseleave", end);
    signaturePad.addEventListener("touchstart", start);
    signaturePad.addEventListener("touchmove", move);
    signaturePad.addEventListener("touchend", end);
    // iOS fires touchcancel liberally (system gestures, notification
    // banners, an extra palm/thumb touch). Treat it as end-of-stroke.
    signaturePad.addEventListener("touchcancel", end);

    signatureClearBtn.addEventListener("click", function () {
      ctx.clearRect(0, 0, signaturePad.width, signaturePad.height);
      signed = false;
    });

    // Resize once layout has settled.
    resize();
    // Keep the buffer in sync on orientation / window resize. Height-only
    // resizes (iOS URL-bar churn) are no-ops inside rebufferIfNeeded.
    window.addEventListener("resize", rebufferIfNeeded);

    // Expose readers so Phase 1c can grab the signature data URL on submit.
    window.__campForm = window.__campForm || {};
    window.__campForm.getSignatureDataUrl = function () {
      return signed ? signaturePad.toDataURL("image/png") : null;
    };
    // Called by "Register another child" so the new submission re-captures
    // a fresh signature rather than silently reusing the first one.
    // Re-run resize() because the canvas's internal width/height buffer gets
    // lost while the form was display:none (post-submit), which made the
    // follow-up toDataURL return a broken image and aborted submit silently.
    window.__campForm.resetSignaturePad = function () {
      resize();
      ctx.clearRect(0, 0, signaturePad.width, signaturePad.height);
      signed = false;
    };
  }

  // ----------------------------------------------------------------
  // Submit pipeline
  // ----------------------------------------------------------------

  function readFormPayload() {
    function getInput(name) {
      var el = form.querySelector("[name='" + name + "']");
      return el ? el.value.trim() : "";
    }
    var cards = Array.from(childrenContainer.querySelectorAll("[data-child]"));
    var children = cards.map(function (card) {
      var state = readChildState(card);
      return {
        first_name: state.first_name,
        last_name: state.last_name,
        jewish_name: state.jewish_name,
        dob: state.dob,
        gender: state.gender,
        school: state.school,
        school_year: state.school_year,
        form_id: state.form_id,
        medical: state.medical,
        allergies: state.allergies,
        special_needs: state.special_needs,
        tetanus: !!state.tetanus,
        tetanus_year: state.tetanus_year ? Number(state.tetanus_year) : null,
        contact_consent: !!state.contact_consent,
        transport_location: state.transport_location,
        session_ids: state.sessionIds,
        transport_session_ids: state.transportSessionIds,
        add_on_selections: state.addOnSelections,
      };
    });
    return {
      family: {
        family_name: getInput("family_name"),
        home_phone: getInput("home_phone"),
        street: getInput("street"),
        town: getInput("town"),
        post_code: getInput("post_code"),
      },
      mother: {
        name: getInput("mother_name"),
        hebrew_name: getInput("mother_hebrew_name"),
        mobile: getInput("mother_mobile"),
        work: getInput("mother_work"),
        email: getInput("mother_email"),
      },
      father: {
        name: getInput("father_name"),
        hebrew_name: getInput("father_hebrew_name"),
        mobile: getInput("father_mobile"),
        work: getInput("father_work"),
        email: getInput("father_email"),
      },
      doctor: {
        name: getInput("doctor_name"),
        street: getInput("doctor_street"),
        town: getInput("doctor_town"),
        post_code: getInput("doctor_post_code"),
      },
      emergency: {
        name: getInput("emergency_name"),
        phone: getInput("emergency_phone"),
      },
      children: children,
      signature: window.__campForm && window.__campForm.getSignatureDataUrl
        ? (window.__campForm.getSignatureDataUrl() || "")
        : "",
    };
  }

  // Loose structural mirror of Joi's .email(): something@domain.tld with
  // alphanumeric/hyphen domain labels and an alphabetic TLD of 2+ chars.
  var EMAIL_PATTERN = /^[^\s@]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;

  // Validate the payload AND, as a side effect, mark any offending DOM
  // fields with .is-invalid so the parent sees red borders next to the
  // actual problem. Returns a { message, firstInvalid } pair where
  // `firstInvalid` is the DOM element to focus/scroll to (may be null when
  // the failure is form-wide, e.g. signature missing).
  function validatePayload(payload) {
    clearInvalidMarks();
    var cards = Array.from(childrenContainer.querySelectorAll("[data-child]"));

    function markFamily(name) {
      var el = form.querySelector("[name='" + name + "']");
      if (el) el.classList.add("is-invalid");
      return el;
    }
    function markChildField(card, fieldName) {
      var el = card.querySelector("[data-field='" + fieldName + "']");
      if (el) el.classList.add("is-invalid");
      return el;
    }

    if (!payload.family.family_name || !payload.family.street ||
        !payload.family.town || !payload.family.post_code) {
      var firstFamily = null;
      ["family_name", "street", "town", "post_code"].forEach(function (n) {
        var v = payload.family[n];
        if (!v) {
          var el = markFamily(n);
          if (!firstFamily) firstFamily = el;
        }
      });
      return { message: "Please fill in the family address.", firstInvalid: firstFamily };
    }
    if (!payload.emergency.name || !payload.emergency.phone) {
      var firstEmerg = null;
      if (!payload.emergency.name) firstEmerg = markFamily("emergency_name");
      if (!payload.emergency.phone && !firstEmerg) firstEmerg = markFamily("emergency_phone");
      else if (!payload.emergency.phone) markFamily("emergency_phone");
      return { message: "Emergency contact name and phone are required.", firstInvalid: firstEmerg };
    }
    if (!payload.mother.email && !payload.father.email) {
      var firstEmail = markFamily("mother_email");
      markFamily("father_email");
      return { message: "At least one parent email is required (mother or father).", firstInvalid: firstEmail };
    }
    // Format mirror of the server's Joi .email() rule. The form tag is
    // novalidate, so the browser's own type="email" check never runs; without
    // this a typo like "name@gmail" only failed server-side, where the
    // response was a generic 400 the parent couldn't act on (2026-07-06
    // Edgware incident). Joi additionally checks the TLD against the IANA
    // list (e.g. rejects "gmail.con"); those rare cases are covered by the
    // server 400's hint message rather than duplicating the list here.
    if (payload.mother.email && !EMAIL_PATTERN.test(payload.mother.email)) {
      return { message: "The mother's email address doesn't look right. Please check it.", firstInvalid: markFamily("mother_email") };
    }
    if (payload.father.email && !EMAIL_PATTERN.test(payload.father.email)) {
      return { message: "The father's email address doesn't look right. Please check it.", firstInvalid: markFamily("father_email") };
    }
    if (!payload.children.length) {
      return { message: "Please add at least one child.", firstInvalid: addChildBtn };
    }
    if (payload.children.length > 10) {
      return { message: "A maximum of 10 children can be submitted in one application. Please submit the rest as a separate application.", firstInvalid: null };
    }
    for (var i = 0; i < payload.children.length; i++) {
      var c = payload.children[i];
      var card = cards[i];
      var label = "Child " + (i + 1);
      if (!c.first_name || !c.last_name) {
        var firstName = !c.first_name ? markChildField(card, "first_name") : null;
        var lastName = !c.last_name ? markChildField(card, "last_name") : null;
        return { message: label + ": name is required.", firstInvalid: firstName || lastName };
      }

      // Distinguish "blank" from "typed something the browser couldn't parse"
      // — Chrome/Edge clear el.value when the date is invalid, so the JS
      // payload would otherwise just see an empty string and report "is
      // required" when the parent in fact did type something.
      var dobInput = card.querySelector("[data-field='dob']");
      if (dobInput && dobInput.validity && dobInput.validity.badInput) {
        dobInput.classList.add("is-invalid");
        return { message: label + ": the date of birth you entered is not valid. Please use the date picker, or type DD/MM/YYYY.", firstInvalid: dobInput };
      }
      if (!c.dob) {
        return { message: label + ": date of birth is required.", firstInvalid: markChildField(card, "dob") };
      }
      if (!c.gender) {
        return { message: label + ": gender is required.", firstInvalid: markChildField(card, "gender") };
      }
      if (!c.school_year) {
        return { message: label + ": school year is required.", firstInvalid: markChildField(card, "school_year") };
      }
      if (!c.form_id) {
        return { message: label + ": please choose a group.", firstInvalid: markChildField(card, "form_id") };
      }
      // Mirrors Joi's 1900-2099 integer window. The input's own min/max
      // attributes are inert because the form is novalidate, so a two-digit
      // "85" would otherwise sail through to a generic server rejection.
      if (c.tetanus_year !== null &&
          (!isFinite(c.tetanus_year) || c.tetanus_year % 1 !== 0 ||
           c.tetanus_year < 1900 || c.tetanus_year > 2099)) {
        return { message: label + ": please enter the tetanus year as a full 4-digit year, e.g. 2023.", firstInvalid: markChildField(card, "tetanus_year") };
      }
      if (!c.session_ids.length) {
        var sessionsContainer = card.querySelector("[data-sessions-container]");
        return { message: label + ": please pick at least one session.", firstInvalid: sessionsContainer };
      }
      // Transport sanity: every session flagged for transport must also be one
      // the child is attending, and picking any transport session requires a
      // pickup location. The UI hides the transport checkboxes until a location
      // is picked but a pathological "pick location, tick sessions, clear
      // location" flow would otherwise submit.
      var selectedSet = {};
      c.session_ids.forEach(function (sid) { selectedSet[sid] = 1; });
      for (var ti = 0; ti < c.transport_session_ids.length; ti++) {
        if (!selectedSet[c.transport_session_ids[ti]]) {
          return { message: label + ": transport can only be requested for sessions the child is attending.", firstInvalid: card.querySelector("[data-transport-sessions]") };
        }
      }
      if (c.transport_session_ids.length && !c.transport_location) {
        return { message: label + ": please pick a transport pickup location.", firstInvalid: markChildField(card, "transport_location") };
      }
    }
    if (!payload.signature) {
      return { message: "Please sign in the signature box.", firstInvalid: signaturePad };
    }
    // Mirrors Joi's 150,000-char cap on the signature data URL. Practically
    // unreachable with a normal signature, but a very high-DPI screen plus a
    // heavily scribbled box could cross it.
    if (payload.signature.length > 150000) {
      return { message: "The signature image is too large to save. Please clear the signature box and sign again.", firstInvalid: signaturePad };
    }
    return null;
  }

  function clearInvalidMarks() {
    form.querySelectorAll(".is-invalid").forEach(function (el) {
      el.classList.remove("is-invalid");
    });
  }

  function showSubmitError(msg, firstInvalid) {
    submitError.textContent = msg || "";
    submitError.hidden = !msg;
    if (msg) {
      submitError.classList.add("is-prominent");
    } else {
      submitError.classList.remove("is-prominent");
    }
    if (msg && firstInvalid && typeof firstInvalid.scrollIntoView === "function") {
      // Scroll the offending field into the middle of the viewport so the
      // parent sees both the field's red border and the global error block.
      // Focus is delayed so the smooth scroll has time to run before the
      // browser jumps focus.
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(function () {
        if (typeof firstInvalid.focus === "function") {
          try { firstInvalid.focus({ preventScroll: true }); } catch (_e) { firstInvalid.focus(); }
        }
      }, 250);
    } else if (msg) {
      // No specific field — at least scroll the error block into view so the
      // parent isn't left wondering why submit didn't do anything.
      submitError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function setSubmitting(on) {
    submitBtn.disabled = !!on;
    submitBtn.textContent = on ? "Submitting…" : "Submit application";
  }

  // Submission state carried across the first submit and any "Register another
  // child" follow-ups. `submittedParentId` gates the endpoint choice: null =>
  // POST /:token (creates the parent), set => POST /:token/add-children
  // (appends to the existing parent so the deposit step aggregates correctly).
  var submittedParentId = null;

  async function handleSubmit(ev) {
    ev.preventDefault();
    showSubmitError("");

    var payload = readFormPayload();
    var clientErr = validatePayload(payload);
    if (clientErr) {
      showSubmitError(clientErr.message, clientErr.firstInvalid);
      return;
    }

    var isFollowUp = !!submittedParentId;
    var url = isFollowUp
      ? "/" + encodeURIComponent(token) + "/add-children"
      : "/" + encodeURIComponent(token);
    var requestBody = isFollowUp
      ? {
          parent_id: submittedParentId,
          children: payload.children,
          signature: payload.signature,
        }
      : payload;

    setSubmitting(true);
    try {
      var resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
      var body = null;
      try { body = await resp.json(); } catch (_e) { /* non-json 500 etc. */ }
      if (!resp.ok || !body || body.ok !== true) {
        showSubmitError((body && body.error) || "Submission failed. Please try again.");
        setSubmitting(false);
        return;
      }
      submittedParentId = body.parentId;
      window.scrollTo(0, 0);
      // body.count is the family total (cumulative) from both endpoints.
      if (bundle.depositEnabled && body.depositAmount > 0) {
        showPostSubmitStep({
          count: body.count,
          depositAmount: body.depositAmount,
          parentId: body.parentId,
          showDeposit: true,
        });
      } else {
        showPostSubmitStep({
          count: body.count,
          depositAmount: 0,
          parentId: body.parentId,
          showDeposit: false,
        });
      }
    } catch (err) {
      showSubmitError("Network error. Please check your connection and try again.");
      setSubmitting(false);
    }
  }

  // ----------------------------------------------------------------
  // Post-submit step (thank-you / deposit / register-another-child)
  // ----------------------------------------------------------------

  // The post-submit UI is rendered into a dedicated panel that replaces the
  // form visually; the form itself is hidden but kept in the DOM so "Register
  // another child" can un-hide it with family fields still populated. We do
  // NOT wipe the container because that would also blow away the form state
  // the follow-up submission relies on.
  function getPostSubmitPanel() {
    var existing = document.getElementById("post-submit-panel");
    if (existing) return existing;
    var panel = document.createElement("section");
    panel.className = "panel success";
    panel.id = "post-submit-panel";
    document.querySelector(".container").appendChild(panel);
    return panel;
  }

  function hidePostSubmitPanel() {
    var panel = document.getElementById("post-submit-panel");
    if (panel) panel.hidden = true;
  }

  function showPostSubmitStep(opts) {
    var panel = getPostSubmitPanel();
    panel.hidden = false;
    form.hidden = true;

    var count = opts.count;
    var amount = opts.depositAmount;
    var parentId = opts.parentId;
    var showDeposit = !!opts.showDeposit;

    var html = "";
    html += '<h2>Application submitted!</h2>';
    html += '<p>We have received your application for ' + count + ' child' +
      (count === 1 ? '' : 'ren') + '.</p>';

    if (showDeposit) {
      html += '<div class="deposit-step">';
      html += '<p>A deposit of <strong>' + formatMoney(amount) + '</strong> is required to confirm your application.</p>';
      html += '<button type="button" class="btn primary" id="pay-deposit-btn">Pay deposit now</button>';
      html += '<p style="margin-top:0.5rem;">';
      html += '<button type="button" class="btn secondary" id="add-another-child-btn">Register another child first</button>';
      html += '</p>';
      html += '<p style="margin-top:0.5rem;">';
      html += '<button type="button" class="btn link" id="skip-deposit-btn">Skip deposit — I\u2019ll pay later</button>';
      html += '</p>';
      html += '<div class="validation-error" id="deposit-error" hidden></div>';
      html += '</div>';
    } else {
      html += '<p>You will receive an email confirmation shortly.</p>';
      html += '<p style="margin-top:1rem;">';
      html += '<button type="button" class="btn secondary" id="add-another-child-btn">Register another child</button>';
      html += '</p>';
    }
    panel.innerHTML = html;

    var addAnotherBtn = document.getElementById("add-another-child-btn");
    if (addAnotherBtn) {
      addAnotherBtn.addEventListener("click", function () { startAdditionalChild(); });
    }
    if (showDeposit) {
      document.getElementById("pay-deposit-btn").addEventListener("click", function () {
        payDeposit(parentId);
      });
      document.getElementById("skip-deposit-btn").addEventListener("click", function () {
        confirmDialog({
          title: "Skip deposit?",
          message: "Camp staff will not be able to see your application until the deposit is paid. You can pay later from the link in your confirmation email.",
          confirmLabel: "Skip",
          cancelLabel: "Go back",
        }).then(function (ok) {
          if (ok) showFinalThankYou(count);
        });
      });
    }
  }

  function showFinalThankYou(count) {
    var panel = getPostSubmitPanel();
    panel.hidden = false;
    form.hidden = true;
    panel.innerHTML =
      '<h2>Thank you — your application has been submitted.</h2>' +
      '<p>We have received your application for ' + count + ' child' +
      (count === 1 ? '' : 'ren') + '. You will receive an email confirmation shortly.</p>';
  }

  // Reset the form UI so the parent can fill in another child (or batch of
  // children) without re-entering family details. Family / parent / doctor /
  // emergency fields stay populated; children + signature are cleared. On the
  // next submit, `submittedParentId` routes the POST to /:token/add-children.
  //
  // The family-level panels are also locked read-only: the add-children
  // endpoint re-uses the stored family profile and never writes back the
  // payload's family fields, so any edit the parent typed here would be
  // silently dropped. Clearer to show them as not-editable up front.
  function startAdditionalChild() {
    hidePostSubmitPanel();
    form.hidden = false;
    childrenContainer.innerHTML = "";
    childIndex = 0;
    if (typeof window.__campForm.resetSignaturePad === "function") {
      window.__campForm.resetSignaturePad();
    }
    lockFamilyPanels();
    addChild();
    setSubmitting(false);
    if (submitBtn) submitBtn.textContent = "Submit additional child";
    showSubmitError("");
    updateReview();
    window.scrollTo(0, 0);
  }

  // Locks every panel marked `data-family-panel` in views/form.ejs (family,
  // mother, father, doctor, emergency) — the children / consent / review
  // panels stay editable. Idempotent. Using a data attribute rather than a
  // "first N panels" count protects against a template re-order silently
  // locking the wrong section.
  function lockFamilyPanels() {
    var panels = form.querySelectorAll("section.panel[data-family-panel]");
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      panel.classList.add("is-locked");
      var inputs = panel.querySelectorAll("input, select, textarea");
      for (var j = 0; j < inputs.length; j++) {
        var el = inputs[j];
        if (el.tagName === "SELECT") {
          el.disabled = true;
        } else {
          el.readOnly = true;
        }
      }
      if (i === 0 && !panel.querySelector(".locked-note")) {
        var note = document.createElement("p");
        note.className = "locked-note";
        note.textContent = "Family details from your first submission are locked here. Contact the camp office if you need to update them.";
        var h2 = panel.querySelector("h2");
        if (h2 && h2.nextSibling) panel.insertBefore(note, h2.nextSibling);
        else if (h2) panel.appendChild(note);
        else panel.insertBefore(note, panel.firstChild);
      }
    }
  }

  async function payDeposit(parentId) {
    var btn = document.getElementById("pay-deposit-btn");
    var errorEl = document.getElementById("deposit-error");
    btn.disabled = true;
    btn.textContent = "Redirecting to payment\u2026";
    errorEl.hidden = true;

    try {
      var resp = await fetch("/" + encodeURIComponent(token) + "/create-deposit-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ parentId: parentId }),
      });
      var data = null;
      try { data = await resp.json(); } catch (_e) { /* non-json 500 */ }
      if (!resp.ok || !data || !data.url) {
        errorEl.textContent = (data && data.error) || "Could not start payment. Please try again.";
        errorEl.hidden = false;
        btn.disabled = false;
        btn.textContent = "Pay deposit now";
        return;
      }
      // Break out of iframe for Stripe Checkout (sets X-Frame-Options: DENY)
      if (window.top !== window.self) {
        window.top.location.href = data.url;
      } else {
        window.location.href = data.url;
      }
    } catch (err) {
      errorEl.textContent = "Network error. Please check your connection and try again.";
      errorEl.hidden = false;
      btn.disabled = false;
      btn.textContent = "Pay deposit now";
    }
  }

  // ----------------------------------------------------------------
  // Boot
  // ----------------------------------------------------------------

  addChildBtn.addEventListener("click", addChild);
  addChild(); // start with one child card visible
  initSignaturePad();

  // Enable submit now that the full pipeline is wired.
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = "Submit application";
  }
  if (submitHint) submitHint.hidden = true;
  form.addEventListener("submit", handleSubmit);

  // Clear the red .is-invalid highlight as soon as the parent starts fixing
  // the field, so they get immediate feedback that they've addressed it.
  form.addEventListener("input", function (e) {
    if (e.target && e.target.classList && e.target.classList.contains("is-invalid")) {
      e.target.classList.remove("is-invalid");
    }
  });
  form.addEventListener("change", function (e) {
    if (e.target && e.target.classList && e.target.classList.contains("is-invalid")) {
      e.target.classList.remove("is-invalid");
    }
  });
})();
